<template>
  <v-app>
    <navigation></navigation>
    <v-content transition="fade-transistion">
      <keep-alive><router-view /></keep-alive>
    </v-content>
  </v-app>
</template>

<script>
import Navigation from "@/components/Navigation";
export default {
  name: "App",
  components: {
    Navigation
  }
};
</script>

<style></style>
